import { Injectable } from '@angular/core';
import { KeycloakEventTypeLegacy, KeycloakService } from 'keycloak-angular';
import { WorkspaceService } from './workspace.service';

@Injectable({
  providedIn: 'root',
})
export class AuthService {
  constructor(
    private _keycloakService: KeycloakService,
    private _workspaceService: WorkspaceService,
  ) {
    _keycloakService.keycloakEvents$.subscribe({
      next: (e) => {
        if (e.type === KeycloakEventTypeLegacy.OnTokenExpired) {
          _keycloakService.updateToken(270000).then(() => {
            console.log('Token updated');
          });
        }
      },
    });
  }

  logout(): void {
    const redirectUrl = this._workspaceService.getCurrentWorkspace()?.logout_url;
    this.clearLocalStorage();
    this._keycloakService.logout(redirectUrl).then();
  }

  get userId(): string | undefined {
    return this._keycloakService.getKeycloakInstance().tokenParsed?.['sub'];
  }

  private clearLocalStorage(): void {
    const keysToKeep = new Set(['hideOnboardingTutorial', 'CLASSROOM_THEME']);

    Object.keys(localStorage).forEach((key) => {
      if (!keysToKeep.has(key)) {
        localStorage.removeItem(key);
      }
    });
  }
}
